import { createSelectorCreator, defaultMemoize } from 'reselect'
import { is } from 'immutable'

export const immutableSelector = createSelectorCreator(defaultMemoize, is)

export function applySelectors(selectors, state) {
  const appliedSelectors = {}
  for (const key of Object.keys(selectors)) {
    const selector = selectors[key]
    appliedSelectors[key] = selector(state)
  }

  return appliedSelectors
}



// WEBPACK FOOTER //
// ./src/scripts/utils/selectors.js